export default __webpack_public_path__ + "static/media/img_shouye_jishu_04.65634461.png";